export interface AuthWithTokenReq {
  cxoneHost: string;
  accessToken: string;
}
